var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 121,
    viewBox: "0 0 169 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 168.661,
    height: 120.472,
    rx: 12.047,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M36.141 28.914h95.932v62.574H36.141z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M71.459 39.816h25.306v40.763H71.459z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.064 60.2c-.006-7.953 3.696-15.467 10.04-20.378-10.777-8.352-26.254-7.136-35.553 2.795a25.66 25.66 0 0 0 0 35.173c9.3 9.931 24.776 11.148 35.553 2.795-6.346-4.912-10.048-12.43-10.04-20.385z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.031 75.258v2.044h-.201v-1.548l-.313 1.33h-.217l-.313-1.33v1.548h-.209v-2.044h.289l.337 1.46.338-1.46h.289zm-1.858.35v1.694h-.176v-1.694h-.378v-.35h.956v.35h-.402zM126.637 60.2c0 9.925-5.747 18.979-14.799 23.316s-19.82 3.197-27.732-2.938C90.447 75.664 94.15 68.15 94.15 60.197c0-7.954-3.703-15.467-10.044-20.381 7.912-6.135 18.68-7.275 27.732-2.938s14.799 13.39 14.799 23.315v.008z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.e4da7303da5344141b37a6b4868aa7f3.svg";
export { ForwardRef as ReactComponent };